<template>
    <div class="widget"
    :class="[$attrs.standalone ? 'alternativ-standalone' : 'plan-widget']">
        <PDFViewer
            v-if="url && active"
            :url="url"
            :hasFunnel="hasFunnel"
        />
        <FunnelFooter
            v-if="hasFunnel"
        />
    </div>
</template>

<script>
    import Http from '@/api/data';
    import { EventBus } from "@/event-bus";
    import { mapActions, mapGetters } from 'vuex';

    import PDFViewer from '@/components/pdfViewer/PDFViewer.vue';
    import FunnelFooter from '@/components/funnel/FunnelFooter.vue';

    export default {
        name: 'Plan',
        components: {
            PDFViewer,
            FunnelFooter
        },
        props: [
            'link',
            'active'
        ],
        data: () => ({
            url: null
        }),
        computed: {
        ...mapGetters([
                'isOfflineMode',
                'isReviewUse',
                'language',
                'protocol',
                'isIframe'
            ]),
            ...mapGetters('widget', [
                'funnel'
            ]),
            apiUrl() {
                return 'https://' + (this.isReviewUse ? process.env.API_LIST.REVIEW : process.env.API_LIST.FO);
            },
            hasFunnel() {
                return this.funnel && !this.isFunnel;
            },
            isFunnel() {
                return this.isIframe && document.referrer === process.env.FUNNEL_URL;
            }
        },
        mounted() {
            this.render();
        },
        methods: {
            ...mapActions([
                'setIsLoading'
            ]),
            render() {
                let urlLink = this.$props.link ? this.$props.link : this.apiUrl + '/request-data/2d-plan' + window.location.search;
                if (this.language && !urlLink.includes('&language'))
                    urlLink += '&language=' + this.language;
                if (this.isOfflineMode && !urlLink.includes('&offline'))
                    urlLink += '&offline';
                Http.getData(urlLink).then(payload => {
                    if (payload) {
                        if (payload.language)
                            this.$i18n.locale = payload.language;
                        this.url = payload.source;
                        EventBus.$emit('trackWidget', payload.tracking);
                        if (this.standalone) {
                            EventBus.$emit('updateLoadedWidgets', {
                                id: '2d-plan',
                                link: urlLink,
                                active: true,
                                widgetType: '2d-plan'
                            });
                        }

                        if (this.$vuetify.breakpoint.smAndDown)
                            EventBus.$emit('closeSidebar');
                        else
                            EventBus.$emit('updateSidebar', payload, false);
                        this.setIsLoading(false);
                    }
                }).catch(error => {
                    this.errorState = true;
                });
            }
        },
        watch: {
            link() {
                if (this.active)
                    this.render();
            }
        }
	};
</script>

<style lang="scss">
    .content-widget{
        iframe{
            position: absolute;
            top: 0;
            left: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/PlanWidget.vue